const toMin = (t) => { const [h, m] = String(t || "0:0").split(":").map(Number); return h * 60 + (m || 0); };

export function weekFrom(d) {
  if (Array.isArray(d?.hours_week) && d.hours_week.length === 7) return d.hours_week;
  const s = String(d?.hours || "").trim();
  if (!s) return null;
  if (/24\s*\/\s*7|24\s*or/i.test(s)) return Array(7).fill({ open: true, h24: true });
  const m = s.match(/(\d{1,2}[:.]\d{2})\s*[-–]\s*(\d{1,2}[:.]\d{2})/);
  if (!m) return null;
  const f = (t) => t.replace(".", ":").padStart(5, "0");
  return Array(7).fill({ open: true, from: f(m[1]), to: f(m[2]), h24: false });
}

// Returns { state: "open" | "closing" | "closed" | "h24" | "closed_today", from, to } or null
export function openInfo(week, now = new Date()) {
  if (!Array.isArray(week) || week.length !== 7) return null;
  const idx = (now.getDay() + 6) % 7;
  const cur = now.getHours() * 60 + now.getMinutes();
  const y = week[(idx + 6) % 7];
  if (y && y.open && !y.h24 && toMin(y.to) <= toMin(y.from) && cur < toMin(y.to)) {
    const left = toMin(y.to) - cur;
    return { state: left <= 60 ? "closing" : "open", from: y.from, to: y.to };
  }
  const h = week[idx];
  if (!h || !h.open) return { state: "closed_today" };
  if (h.h24) return { state: "h24" };
  const from = toMin(h.from), to = toMin(h.to);
  const overnight = to <= from;
  const isOpen = overnight ? cur >= from : cur >= from && cur < to;
  if (!isOpen) return { state: "closed", from: h.from, to: h.to, later: cur < from };
  const left = overnight ? to + 1440 - cur : to - cur;
  return { state: left <= 60 ? "closing" : "open", from: h.from, to: h.to };
}
